import { AUFTRAG_API, BILLING_API } from '@Constants/backendConstants';

/** Root object types a raw attachment can be linked to, and where to resolve its download URL from. */
export const ROOT_OBJECT_ATTACHMENT_CONFIG: Record<string, { baseUrl: string; entityPath: string }> = {
    order: { baseUrl: AUFTRAG_API, entityPath: 'orders' },
    invoice: { baseUrl: BILLING_API, entityPath: 'invoices' },
};
